export enum PlanType {
  Default = 'Default',
  General = 'General'
}
